export default __webpack_public_path__ + "static/media/Le_Baiser_porte_cle_coeur.6f9aea71.png";